import React, { useState, useEffect } from 'react';
import { supabase } from '../../supabaseClient';
import { Bell, ImageIcon, Loader2, MonitorPlay } from 'lucide-react';

export const AlertPublisher = () => {
  const [message, setMessage] = useState('');
  const [targetUser, setTargetUser] = useState('');
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const [type, setType] = useState('info');
  const [mediaUrl, setMediaUrl] = useState('');
  const [coverUrl, setCoverUrl] = useState('');
  const [coverFile, setCoverFile] = useState<File | null>(null); // 👈 Novo estado para upload de arquivo
  const [targetUrl, setTargetUrl] = useState('');
  const [downloadUrl, setDownloadUrl] = useState('');
  const [buttonText, setButtonText] = useState('');

  const [alertTitle, setAlertTitle] = useState('Aviso do Sistema');
  const [history, setHistory] = useState<any[]>([]);

  const fetchHistory = async () => {
    const { data } = await supabase
      .from('app_alerts')
      .select('*')
      .order('created_at', { ascending: false })
      .limit(5);
    setHistory(data || []);
  };

  useEffect(() => { fetchHistory(); }, []);

  const handlePublish = async () => {
    if (!message) return alert("Digite uma mensagem!");
    setLoading(true);

    const cleanId = targetUser.trim() === '' ? null : targetUser.trim();
    
    try {
      let finalCoverUrl = coverUrl.trim() || null;

      // 1. Se o usuário selecionou um arquivo de imagem, faz o upload para o Supabase Storage
      if (coverFile) {
        const fileExt = coverFile.name.split('.').pop();
        const fileName = `alert_${Date.now()}_${Math.random().toString(36).substring(2)}.${fileExt}`;
        
        const { error: uploadError } = await supabase.storage
          .from('videos_feed')
          .upload(fileName, coverFile);

        if (uploadError) {
          throw new Error("Erro no upload da imagem: " + uploadError.message);
        }

        const { data } = supabase.storage
          .from('videos_feed')
          .getPublicUrl(fileName);

        finalCoverUrl = data.publicUrl;
      }

      // 2. Insere o aviso no banco de dados
      const { error } = await supabase.from('app_alerts').insert([
        {
          title: alertTitle,
          message,
          type,
          media_url: mediaUrl || null,
          cover_url: finalCoverUrl,
          target_url: targetUrl || null,
          download_url: downloadUrl || null,
          button_text: buttonText || null,
          is_active: true,
          target_user_id: cleanId,
          scheduled_at: new Date().toISOString()
        }
      ]);

      if (error) throw error;

      setStatus('success');
      alert("Aviso publicado com sucesso!"); 
      
      setMessage(''); setTargetUser(''); setMediaUrl(''); setCoverUrl('');
      setCoverFile(null); setTargetUrl(''); setDownloadUrl(''); setButtonText(''); setType('info');
      fetchHistory();
    } catch (err: any) {
      console.error("ERRO:", err.message);
      alert("Erro ao publicar: " + err.message);
      setStatus('error');
    } finally {
      setLoading(false);
    }
  };

  // Extrator de ID do YouTube para a prévia interativa
  const extrairIdYoutubePlayer = (url: string) => {
    if (!url) return null;
    const ytRegex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/|youtube\.com\/shorts\/)([^"&?\/\s]{11})/;
    const match = url.match(ytRegex);
    return (match && match[1]) ? match[1] : null;
  };

  const youtubeId = extrairIdYoutubePlayer(mediaUrl);
  
  // Define a prévia da imagem (se houver arquivo selecionado, cria URL local temporária)
  const previewImage = coverFile ? URL.createObjectURL(coverFile) : (coverUrl || mediaUrl);

  return (
    <div>
      <style>{`
        .alert-publisher-layout {
          display: grid;
          grid-template-columns: 1fr 380px;
          gap: 25px;
          width: 100%;
          box-sizing: border-box;
        }
        @media (max-width: 768px) {
          .alert-publisher-layout {
            display: flex;
            flex-direction: column-reverse;
            gap: 15px;
          }
        }
      `}</style>

      <div className="alert-publisher-layout">
        {/* Lado Esquerdo: Formulário */}
        <div style={{ backgroundColor: '#111', padding: '25px', borderRadius: '16px', border: '1px solid #333', width: '100%', boxSizing: 'border-box' }}>
          <h3 style={{ color: '#fff', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px', fontSize: '18px' }}>
            <Bell size={20} color="#00ccff" /> Gerenciar Avisos
          </h3>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <select value={type} onChange={(e) => setType(e.target.value)} style={{ width: '100%', backgroundColor: '#1A1A1A', color: '#fff', border: '1px solid #333', borderRadius: '8px', padding: '12px', boxSizing: 'border-box' }}>
              <option value="info">Aviso (Texto)</option>
              <option value="video">Vídeo</option>
              <option value="image">Imagem</option>
            </select>

            <input 
              style={{ width: '100%', backgroundColor: '#1A1A1A', color: '#fff', border: '1px solid #333', borderRadius: '8px', padding: '12px', boxSizing: 'border-box' }} 
              placeholder="Título do Aviso (ex: Manutenção)" 
              value={alertTitle} 
              onChange={(e) => setAlertTitle(e.target.value)} 
            />

            <input style={{ width: '100%', backgroundColor: '#1A1A1A', color: '#fff', border: '1px solid #333', borderRadius: '8px', padding: '12px', boxSizing: 'border-box' }} placeholder="Link da Mídia (URL / YouTube)" value={mediaUrl} onChange={(e) => setMediaUrl(e.target.value)} />
            
            {/* Seção Híbrida para Capa (Upload ou Link) */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label style={{ color: '#aaa', fontSize: '12px' }}>Capa do Aviso (Upload de Arquivo ou Link)</label>
              <input 
                type="file" 
                accept="image/*" 
                onChange={e => setCoverFile(e.target.files?.[0] || null)} 
                style={{ width: '100%', backgroundColor: '#1A1A1A', color: '#fff', border: '1px solid #333', borderRadius: '8px', padding: '8px', boxSizing: 'border-box' }} 
              />
              <input 
                style={{ width: '100%', backgroundColor: '#1A1A1A', color: '#fff', border: '1px solid #333', borderRadius: '8px', padding: '12px', boxSizing: 'border-box' }} 
                placeholder="Ou cole o link da Capa (Thumbnail)" 
                value={coverUrl} 
                onChange={(e) => setCoverUrl(e.target.value)} 
              />
            </div>

            <input style={{ width: '100%', backgroundColor: '#1A1A1A', color: '#fff', border: '1px solid #333', borderRadius: '8px', padding: '12px', boxSizing: 'border-box' }} placeholder="Link de Afiliado" value={targetUrl} onChange={(e) => setTargetUrl(e.target.value)} />
            <input style={{ width: '100%', backgroundColor: '#1A1A1A', color: '#fff', border: '1px solid #333', borderRadius: '8px', padding: '12px', boxSizing: 'border-box' }} placeholder="Link para Download" value={downloadUrl} onChange={(e) => setDownloadUrl(e.target.value)} />
            <input style={{ width: '100%', backgroundColor: '#1A1A1A', color: '#fff', border: '1px solid #333', borderRadius: '8px', padding: '12px', boxSizing: 'border-box' }} placeholder="Texto do Botão" value={buttonText} onChange={(e) => setButtonText(e.target.value)} />
            
            <textarea style={{ width: '100%', backgroundColor: '#1A1A1A', color: '#fff', border: '1px solid #333', borderRadius: '8px', padding: '12px', height: '80px', resize: 'none', boxSizing: 'border-box' }} placeholder="Mensagem..." value={message} onChange={(e) => setMessage(e.target.value)} />
            
            <button disabled={loading} onClick={handlePublish} style={{ width: '100%', padding: '14px', backgroundColor: '#00ccff', border: 'none', borderRadius: '8px', color: '#000', fontWeight: 'bold', cursor: 'pointer', marginTop: '5px' }}>
              {loading ? <Loader2 className="animate-spin" size={16} /> : 'Publicar Aviso'}
            </button>
          </div>
        </div>

        {/* Lado Direito: Prévia 16:9 com Player Interativo */}
        <div style={{ backgroundColor: '#111', padding: '20px', borderRadius: '16px', border: '1px solid #333', display: 'flex', flexDirection: 'column', height: 'fit-content' }}>
          <h4 style={{ color: '#fff', marginTop: 0, fontSize: '15px' }}>PRÉVIA DO AVISO</h4>
          
          <div style={{ aspectRatio: '16/9', backgroundColor: '#1A1A1A', borderRadius: '8px', overflow: 'hidden', border: '1px solid #333', position: 'relative' }}>
            {youtubeId ? (
              <iframe
                src={`https://www.youtube.com/embed/${youtubeId}?autoplay=1`}
                title="Player Preview"
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            ) : previewImage ? (
              <img src={previewImage} style={{ width: '100%', height: '100%', objectFit: 'cover' }} alt="Preview" />
            ) : (
              <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <ImageIcon color="#555" size={40} />
              </div>
            )}
          </div>

          <h4 style={{ color: '#fff', marginTop: '12px', fontSize: '14px' }}>{alertTitle || 'Título do Aviso'}</h4>
          <p style={{ color: '#aaa', fontSize: '12px', margin: '4px 0 15px 0', wordBreak: 'break-word' }}>{message || 'Mensagem do aviso...'}</p>
          
          <button style={{ marginTop: 'auto', width: '100%', padding: '10px', backgroundColor: '#00ccff', color: '#000', border: 'none', borderRadius: '6px', fontWeight: 'bold', fontSize: '12px', cursor: 'pointer' }}>
            {buttonText || 'Acessar'}
          </button>
        </div>
      </div>
    </div>
  );
};